import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3bce8d57"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["id"];
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseBadge',
  props: {
    badgeClass: {
      "default": "tw-badge-w-primary-sm"
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("span", {
        id: _ctx.$attrs.id,
        "class": _normalizeClass(['tw-badge tw-shadow-sm', _ctx.badgeClass, _ctx.$attrs['class']])
      }, [_renderSlot(_ctx.$slots, "default")], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));